import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function EliminarUser (){
    const navigate = useNavigate();
    const [showFacebookModal, setShowFacebookModal] = useState(false);
    const [showGoogleModal, setShowGoogleModal] = useState(false);

    const handleFacebookSubmit = async (e) => {
        e.preventDefault();
        // Aquí envías los datos al backend
        localStorage.removeItem('usuario');
        navigate('/')
        setShowFacebookModal(false);
    };

    const handleGoogleSubmit = async (e) => {
        e.preventDefault();
        // Aquí envías los datos al backend
        localStorage.removeItem('usuario');
        navigate('/')
        setShowGoogleModal(false);
    };

    return (
        <>
            <div className="justify-self-center mt-40 min-h-screen">
                <div className=" grid bg-zinc-100 gap-4 pt-20 rounded m-20 p-20">
                    <button onClick={() => setShowFacebookModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded">
                        Solicitar baja por Facebook
                    </button>
                    <button onClick={() => setShowGoogleModal(true)} className="bg-red-500 text-white px-4 py-2 rounded mt-4">
                        Solicitar baja por Google
                    </button>

                    {showFacebookModal && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <form onSubmit={handleFacebookSubmit} className="bg-white p-8 rounded shadow-md w-96">
                                <div className='pb-10'>
                                <h2 className="text-lg font-bold mb-4">¿Confirmás dar de baja tu cuenta de Facebook?</h2>
                                <span className='text-sm'>Debe estar logueado para dar de baja el usuario. Una vez, realizada esta opcion, no podra volver hacia atras.</span>
                                </div>
                                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded mr-2">Confirmar</button>
                                <button type="button" onClick={() => setShowFacebookModal(false)} className="ml-2 px-4 py-2 rounded border">
                                    Cancelar
                                </button>
                            </form>
                        </div>
                    )}

                    {showGoogleModal && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <form onSubmit={handleGoogleSubmit} className="bg-white p-8 rounded shadow-md w-96">
                                <div className='pb-10'>
                                <h2 className="text-lg font-bold mb-4">¿Confirmás dar de baja tu cuenta de Google?</h2>
                                <span className='text-sm'>Debe estar logueado para dar de baja el usuario. Una vez, realizada esta opcion, no podra volver hacia atras.</span>
                                </div>
                                <button type="submit" className="bg-red-500 text-white px-4 py-2 rounded mr-2">Confirmar</button>
                                <button type="button" onClick={() => setShowGoogleModal(false)} className="ml-2 px-4 py-2 rounded border">
                                    Cancelar
                                </button>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}